<div class="w-full flex align-items-center justify-content-center bg-center bg-cover border-bottom-1 border-primary"
    style="background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #36DEFB 100%); min-height: 20rem;">
    <div class="flex flex-column justify-content-center align-items-center text-center px-4">
        <h1 class="text-white text-5xl md:text-6xl lg:text-7xl font-bold mb-3">Our Services</h1>
        <ul class="list-none flex align-items-center justify-content-center p-0 m-0">
            <li>
                <a routerLink="/"
                    class="cursor-pointer text-white text-lg md:text-2xl font-light hover:text-primary transition-colors transition-duration-150 no-underline">Home</a>
            </li>
            <li class="mx-2">
                <i class="pi pi-angle-double-right text-white text-lg md:text-2xl font-light"></i>
            </li>
            <li>
                <span class="text-primary text-lg md:text-2xl font-light">Services</span>
            </li>
        </ul>
    </div>
</div>

<!-- SERVICES INTRO -->
<section class="bg-white py-8 overflow-hidden" data-prerender>
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1537px;">
        <div class="grid align-items-center">
            <div class="col-12 lg:col-6 mb-6 lg:mb-0 pr-0 lg:pr-8">
                <span class="text-primary-deep font-bold text-lg uppercase tracking-widest block mb-3">What We Do</span>
                <h2 class="text-900 text-4xl md:text-6xl font-bold leading-tight mb-5">Software and services around <span
                        class="text-primary-deep">one platform</span></h2>
                <p class="text-600 text-xl line-height-4 mb-6">
                    ESZES builds and runs BMS, then does the work around it: implementation, integration, custom
                    applications and cloud operations. Everything below is delivered by the team that writes the software.
                </p>
                <div class="flex align-items-center gap-4">
                    <div class="flex flex-column">
                        <span class="text-900 text-4xl font-bold">16+</span>
                        <span class="text-600 font-medium">Modules in the suite</span>
                    </div>
                    <div class="w-1px h-3rem bg-gray-200 mx-2"></div>
                    <div class="flex flex-column">
                        <span class="text-900 text-4xl font-bold">16+</span>
                        <span class="text-600 font-medium">Live tenant deployments</span>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-6">
                <div class="relative">
                    <div class="absolute -top-4 -right-4 w-12rem h-12rem bg-primary-alpha-10 border-circle z-0"></div>
                    <lottie-player src="assets/lottie/services-intro.json" background="transparent" speed="1"
                        style="width: 100%; height: 400px;" loop autoplay></lottie-player>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- SERVICES GRID - PROFESSIONAL DARK CARDS -->
<section class="bg-gray-900 py-8 relative overflow-hidden">
    <!-- Decorative Background -->
    <div class="absolute top-0 left-0 w-full h-full opacity-10"
        style="background-image: radial-gradient(circle at 2px 2px, #36DEFB 1px, transparent 0); background-size: 30px 30px;">
    </div>

    <div class="mx-auto px-4 md:px-6 lg:px-8 relative z-1" style="max-width: 1647px;">
        <div class="text-center mb-8">
            <span class="text-primary font-bold text-lg uppercase tracking-widest block mb-3">The offering</span>
            <h2 class="text-white text-4xl md:text-5xl font-bold">What we deliver</h2>
        </div>

        <div class="grid">
            <div class="col-12 md:col-6 lg:col-4 p-4 service-anchor" [id]="service.id" *ngFor="let service of services; let i = index">
                <div class="service-card bg-white-alpha-5 backdrop-blur-lg p-6 border-round-3xl shadow-2 h-full border-1 border-white-alpha-10 flex flex-column animate-fadeInUp hover:bg-white-alpha-10"
                    [style.animation-delay]="(i * 0.1) + 's'">
                    <div
                        class="icon-box w-4rem h-4rem bg-white-alpha-10 border-round-2xl flex align-items-center justify-content-center mb-6 shadow-2">
                        <i [class]="service.icon + ' text-primary text-3xl'"></i>
                    </div>
                    <h3 class="text-white text-2xl md:text-3xl font-bold mb-4">{{ service.title }}</h3>
                    <p class="text-gray-400 line-height-3 text-lg mb-6 flex-grow-1">
                        {{ service.description }}
                    </p>
                    <div class="border-top-1 border-white-alpha-10 pt-6 mt-auto">
                        <ul class="list-none p-0 m-0 mb-6">
                            <li class="flex align-items-center gap-3 mb-3" *ngFor="let feature of service.features">
                                <div
                                    class="w-1.5rem h-1.5rem bg-primary-alpha-10 border-circle flex align-items-center justify-content-center">
                                    <i class="pi pi-check text-primary text-xs font-bold"></i>
                                </div>
                                <span class="text-gray-300 font-medium">{{ feature }}</span>
                            </li>
                        </ul>
                        <a routerLink="/contact" [queryParams]="{ about: service.title }"
                            class="inline-flex align-items-center gap-2 text-primary font-bold no-underline hover:underline">
                            <span>Talk to us about this</span>
                            <i class="pi pi-arrow-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PROCESS SECTION - PROFESSIONAL PATH -->
<section class="bg-white py-8 overflow-hidden">
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1647px;">
        <div class="text-center mb-8">
            <span class="text-primary-deep font-bold text-lg uppercase tracking-widest block mb-3">Workflow</span>
            <h2 class="text-900 text-4xl md:text-5xl font-bold">How an engagement runs</h2>
            <p class="text-600 text-lg max-w-30rem mx-auto mt-3">Four steps from first call to go-live, whether you take one module or the whole suite.</p>
        </div>

        <div class="grid mt-8 relative">
            <!-- Background Path Line (Desktop) -->
            <div class="hidden lg:block absolute w-full h-2px bg-gray-100 z-0" style="top: 3.5rem; left: 0;">
                <div class="h-full bg-primary-alpha-20 w-full"></div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 p-4 text-center group workflow-step"
                *ngFor="let step of processSteps; let i = index">
                <div class="relative z-1">
                    <!-- Icon Container -->
                    <div
                        class="step-icon-container w-7rem h-7rem bg-white border-circle mx-auto flex align-items-center justify-content-center shadow-4 border-2 border-gray-100 group-hover:border-primary group-hover:shadow-8 transition-all transition-duration-500 mb-6 relative overflow-hidden">
                        <!-- Subtle Glow -->
                        <div
                            class="absolute top-0 left-0 w-full h-full bg-primary opacity-0 group-hover:opacity-10 transition-opacity">
                        </div>

                        <i
                            [class]="step.icon + ' text-900 text-4xl group-hover:text-primary transition-colors transition-duration-300'"></i>
                    </div>

                    <h3 class="text-900 text-2xl font-bold mb-3 group-hover:text-primary transition-colors">{{
                        step.title }}</h3>
                    <p class="text-700 line-height-3 px-3 m-0">{{
                        step.description }}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- CTA SECTION -->
<section class="bg-gray-900 py-6 relative overflow-hidden">
    <div class="absolute top-0 left-0 w-full h-full opacity-20"
        style="background: radial-gradient(circle at center, #36DEFB 0%, transparent 70%);"></div>
    <div class="mx-auto px-4 md:px-6 lg:px-8 text-center relative z-1" style="max-width: 1000px;">
        <h2 class="text-white text-3xl md:text-5xl font-bold mb-4 mt-0 lg:mt-6 tracking-tight">Start with <span
                class="text-primary-deep">one module</span>, or the whole suite</h2>
        <p class="text-gray-400 text-lg mb-6 max-w-30rem mx-auto line-height-3">
            Tell us what you run today. We will map it onto BMS and show you the modules live before you commit.
        </p>
        <div class="flex gap-3 justify-content-center flex-wrap mb-5">
            <button pButton label="Talk to us" routerLink="/contact"
                class="p-button-primary p-button-rounded px-6 py-3 font-bold text-base shadow-4 hover:shadow-8 transition-all transition-duration-300"></button>
            <button pButton label="Try the free edition" routerLink="/free-software"
                class="p-button-outlined p-button-secondary text-white border-white p-button-rounded px-6 py-3 font-bold text-base hover:bg-white-alpha-10 transition-all transition-duration-300"></button>
        </div>
    </div>
</section>